import { Tag } from "primereact/tag";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import {
	LicenseProductDataContentKind,
	ProductTypeColumn_ProductFragment$key,
} from "@relay/ProductTypeColumn_ProductFragment.graphql";

const PRODUCT_TYPE_FRAGMENT = graphql`
	fragment ProductTypeColumn_ProductFragment on Product {
		data {
			... on LicenseProductData {
				content {
					kind
				}
			}
		}
	}
`;

type OwnProps = {
	productFragmentRef: ProductTypeColumn_ProductFragment$key;
};

export const ProductTypeColumn = ({ productFragmentRef }: OwnProps) => {
	const { t } = useTranslation("common");
	const product = useFragment<ProductTypeColumn_ProductFragment$key>(
		PRODUCT_TYPE_FRAGMENT,
		productFragmentRef,
	);

	const kind = product.data.content?.kind;

	const severityMap: Record<LicenseProductDataContentKind | "default", "info" | "success"> = {
		CourseWithCertificationContent: "info",
		CertificationContent: "success",
		CourseContent: "success",
		default: "info",
	};

	return (
		<Tag
			value={t(`product.${kind ?? "CourseWithCertificationContent"}`)}
			severity={severityMap[kind ?? "default"]}
		/>
	);
};
